import { InjectionToken, inject } from "@angular/core";
import { ClientState } from "app/models/client/client-state";
import { debounceTime, map, merge, Observable, repeat, retry, shareReplay, switchMap, throwError } from "rxjs";
import { ClientService } from "./client.service";
import { UserService } from "./user.service";
import { SignalRService } from "./signal-r.service";
import { HttpErrorResponse } from "@angular/common/http";

export const CLIENT_STATE = new InjectionToken<Observable<ClientState>>('clientState',
  {
    factory: () => {
      const userService = inject(UserService);
      const clientService = inject(ClientService);
      const signalRService = inject(SignalRService);
      return userService.user$.pipe(
        switchMap((user) => clientService.clientState(user.id).pipe(
          // switchMap(() => throwError(() => new HttpErrorResponse({ error: {} }))),
          repeat({ delay: () => merge(signalRService.isReconnected$, clientService.refreshState$.pipe(debounceTime(1500))) }),
          retry({
            delay(error, retryCount) {
              if (retryCount <= 3) {
                return merge(signalRService.isReconnected$, clientService.refreshState$.pipe(debounceTime(1500)))
              }

            },
          })
        )),
        shareReplay({ bufferSize: 1, refCount: true }),
      );
    }
  }
);